export default __webpack_public_path__ + "static/media/pivotMaximise.9ccb6887.svg";